import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonSearchList = ({ count = 20 }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div
          className="d-flex justify-content-between align-items-center mb-3"
          key={index}
        >
          <div className="d-flex align-items-center">
            <Skeleton circle height={50} width={50} className="mr-2" />
            <div>
              <Skeleton height={15} width={Math.random() * 70 + 65} />
              <Skeleton height={12} width={50} />
            </div>
          </div>

          <div>
            <Skeleton height={33} width={110} borderRadius={20} />
          </div>
        </div>
      ))}
    </>
  );
};

export default SkeletonSearchList;
